import { render, staticRenderFns } from "./OrderItemsModal.vue?vue&type=template&id=68c2d782&scoped=true"
import script from "./OrderItemsModal.vue?vue&type=script&lang=js"
export * from "./OrderItemsModal.vue?vue&type=script&lang=js"
import style0 from "./OrderItemsModal.vue?vue&type=style&index=0&id=68c2d782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c2d782",
  null
  
)

export default component.exports